import { X, TrendingDown } from "lucide-react";
import type { ConnectsRecovery } from "../../store/useBdStore";

const money = (n: number) =>
  `$${(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;


export function ConnectsRecoveryModal({
  data,
  onClose,
}: {
  data: ConnectsRecovery | null;
  onClose: () => void;
}) {
  const months = data?.months || [];
  console.log(months,"here is the monthssss")
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-surface-container-lowest w-full max-w-3xl max-h-[90vh] flex flex-col rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-outline-variant">
          <div>
            <h2 className="text-lg font-bold text-on-surface flex items-center gap-2">
              <TrendingDown size={18} className="text-primary" /> Connects Cost Recovery
            </h2>
            <p className="text-[11px] text-on-surface-variant mt-0.5">
              Connects spend recovered from revenue won — unrecovered balance carries forward.
              Rate: ${data?.costPerConnect ?? 0}/connect.
            </p>
          </div>
          <button onClick={onClose} className="p-1.5 text-outline hover:bg-surface-container rounded-full">
            <X size={18} />
          </button>
        </div>

        <div className="grid grid-cols-3 gap-3 px-6 py-4 border-b border-outline-variant">
          <Stat label="Current Backlog" value={money(data?.currentOutstanding || 0)} danger={(data?.currentOutstanding || 0) > 0} />
          <Stat label="Total Connects Cost" value={money(data?.totalConnectsCost || 0)} />
          <Stat label="Total Recovered" value={money(data?.totalRecovered || 0)} />
        </div>

        <div className="cre-scroll overflow-y-auto flex-1">
          {months.length === 0 ? (
            <div className="text-center py-12 text-outline">No connects activity yet.</div>
          ) : (
            <table className="w-full text-left text-sm">
              <thead className="bg-surface-container-low text-[11px] font-bold uppercase tracking-wide text-on-surface-variant sticky top-0">
                <tr>
                  {["Month", "Connects", "Cost", "Won", "Exp. Revenue", "Released", "Recovered", "Outstanding", "Rate"].map((h) => (
                    <th key={h} className="px-3 py-2.5 whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-outline-variant">
                {months.map((m) => (
                  <tr key={`${m.year}-${m.month}`} className="hover:bg-surface-container-low/60">
                    <td className="px-3 py-2.5 font-medium text-on-surface whitespace-nowrap">{m.label}</td>
                    <td className="px-3 py-2.5">{m.connectsUsed}</td>
                    <td className="px-3 py-2.5">{money(m.connectsCost)}</td>
                    <td className="px-3 py-2.5">{m.projectsWon}</td>
                    <td className="px-3 py-2.5 text-[#10b981]">{money(m.revenue)}</td>
                    <td className="px-3 py-2.5 text-on-surface font-medium">{money(m.released)}</td>
                    <td className="px-3 py-2.5">{money(m.recovered)}</td>
                    <td className={`px-3 py-2.5 font-bold ${m.outstanding > 0 ? "text-error" : "text-on-surface-variant"}`}>
                      {money(m.outstanding)}
                    </td>
                    <td className="px-3 py-2.5">
                      <span className={`font-semibold ${m.recoveryRate >= 80 ? "text-[#10b981]" : m.recoveryRate >= 40 ? "text-amber-600" : "text-error"}`}>
                        {m.recoveryRate}%
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

const Stat = ({ label, value, danger }: { label: string; value: string; danger?: boolean }) => (
  <div className="bg-surface-bright border border-outline-variant rounded-lg p-3">
    <div className="text-[10px] font-semibold text-outline uppercase tracking-wide">{label}</div>
    <div className={`text-lg font-bold mt-1 ${danger ? "text-error" : "text-on-surface"}`}>{value}</div>
  </div>
);
